import { Box, CircularProgress,Button, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import PaymentCard from "./PaymentCardSalon";
import CombinationCard from "./CombinationCard";
import YourBookingCard from "./YourBookingCardSalon";
import AddressCard from "./AddressCardSalon";
import { useSelector } from "react-redux";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import ArrowForwardIosTwoToneIcon from "@mui/icons-material/ArrowForwardIosTwoTone";
import { format_Number } from "../../utils/utils";
import ArrowBackIosTwoToneIcon from "@mui/icons-material/ArrowBackIosTwoTone";
const CardSection = (
  {
    steps,
    activeStep,
    handleBack,
    handleNextFunc,
    price,
    isLoading,
    errors,
    touched,
    values
  }
) => {
  const{css}=useSelector((store)=> store?.widgetSettings)
  const Css = css?.find(
    (item) => item?.cssTabFieldsGroupName === "Checkout fields + sidemnu"
  )?.fields
  const hasErrors = Object.keys(errors || {}).some(
    (key) =>
      touched?.[key] ||
      (values?.[key] !== undefined &&
        values?.[key] !== "" &&
        values?.[key] !== false)
  );
  
  const{
    languageWords
     }=useSelector((store)=> store?.salon)
  const theme=useTheme()

  return (
    <Box>
      <AddressCard Css={Css} languageWords={languageWords} />
      <YourBookingCard Css={Css}/>
        <PaymentCard Css={Css}/>
         <Box
sx={{
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  mt: 2,
  gap: 2,
}}
>
{/* Back Icon Button */}
<Button
  onClick={handleBack}
  sx={{
    mr: 1,
    borderRadius: theme?.widget?.backIconRadius ?? "5px",
    backgroundColor:
      Css?.salonnavigationBtnBgClr,
  }}
>
  <ArrowBackIosTwoToneIcon fontSize="small" sx={{color:Css?.salonnavigationBtnIconClr}} />
</Button>

{/* Next / Confirm Icon Button */}
<Button
  onClick={() => handleNextFunc(errors)}
  type={
    steps[activeStep] === languageWords?.yourDetails
      ? "submit"
      : "button"
  }
  disabled={
    hasErrors &&
    steps[activeStep] === languageWords?.yourDetails
  }
  sx={{
    mr: 1,
    backgroundColor:
    Css?.salonnavigationBtnBgClr,
    color: "#fff",
    "&.Mui-disabled": {
      backgroundColor:
        theme?.widget?.stepBtnDisabledBg ?? "#F8F8F8",
      color:
        theme?.widget?.stepBtnDisabledText ?? "grey",
    },
  }}
>
  {isLoading ? (
    <CircularProgress size={20} color="inherit" />
  ) : steps[activeStep] === languageWords?.yourDetails ? (
    <>
    {price > 0 ? (
      <>
        <CreditScoreIcon fontSize="small" />
        {` € ${format_Number(parseFloat(price).toFixed(2))}`}
      </>
    ) : (
     languageWords?.reserve ?? 'Reserve' 
    )}
  </>
  ) : (
    <ArrowForwardIosTwoToneIcon fontSize="small" />
  )}
</Button>
</Box>
    </Box>
  );
};

export default CardSection;


